<mibi-box-layout x-overflow-handling y-overflow-handling>

  <div #scrollContainer class="mibi-page-body">
    <div class="mibi-page-body__spinner" [ngClass]="{'mibi-page-body__spinner--active':isBusy}">
      <mat-spinner *ngIf="isBusy" class="mibi-spinner" color="accent" _forceAnimations="true">
      </mat-spinner>
    </div>
    <div class="mibi-page-body__banner mibi-banner"
      [@bannerSlideAnimation]="getBannerAnimationState()"
      (@bannerSlideAnimation.done)="onBannerAnimationDone($event)"
    >
      <mibi-banner-container></mibi-banner-container>
    </div>
    <div class="mibi-page-body__main"
      [@routerTransitionFadeAnimation]="getRouterAnimationState(mainOutlet)"
      [@routerTransitionAnimation]="getRouterAnimationState(mainOutlet)"
      (@routerTransitionAnimation.done)="onRouterTransitionAnimationDone(scrollContainer)"
    >
      <router-outlet #mainOutlet="outlet"></router-outlet>
    </div>
  </div>

</mibi-box-layout>